module.exports = __webpack_public_path__ + "assets/img/Business_img2.6ae5fcee.png";